import React, { useEffect, useState } from 'react';
import { formatDocumentTypeLabel } from '../../utils/documentTypes';
import './ReprocessConfirmModal.css';

const ReprocessDocumentModal = ({
  isOpen,
  filename,
  docTypes = [],
  loading = false,
  onConfirm,
  onCancel,
}) => {
  const [selectedType, setSelectedType] = useState('');

  useEffect(() => {
    if (isOpen) {
      setSelectedType('');
    }
  }, [isOpen, filename]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && !loading) {
      onCancel?.();
    }
  };

  const handleConfirm = () => {
    if (selectedType && onConfirm) {
      onConfirm(selectedType);
    }
  };

  return (
    <div className="reprocess-modal-overlay" onClick={handleOverlayClick}>
      <div className="reprocess-modal-container reprocess-modal-container--wide" role="dialog" aria-modal="true">
        <div className="reprocess-modal-header">
          <h3 className="reprocess-modal-title">Reprocesar documento</h3>
          <button
            type="button"
            className="reprocess-modal-close"
            onClick={onCancel}
            disabled={loading}
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>

        <p className="reprocess-modal-filename" title={filename}>
          {filename || 'Documento sin nombre'}
        </p>

        <p className="reprocess-modal-subtitle">Elegí el tipo destino:</p>

        <div className="reprocess-type-grid" role="listbox" aria-label="Tipos de documento">
          {docTypes.map((item) => {
            const type = item.document_type;
            const isSelected = selectedType === type;
            return (
              <button
                key={type}
                type="button"
                role="option"
                aria-selected={isSelected}
                className={`reprocess-type-option${isSelected ? ' is-selected' : ''}`}
                onClick={() => setSelectedType(type)}
                disabled={loading}
              >
                <span className="reprocess-type-label">{formatDocumentTypeLabel(type)}</span>
                <span className="reprocess-type-code">{type}</span>
              </button>
            );
          })}
        </div>

        <p className="reprocess-modal-hint">
          Se creará una copia procesada con el tipo elegido. Este documento dejará de aparecer en &quot;Sin clasificar&quot;.
        </p>

        <div className="reprocess-modal-actions">
          <button
            type="button"
            className="reprocess-btn-cancel"
            onClick={onCancel}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="reprocess-btn-confirm"
            onClick={handleConfirm}
            disabled={loading || !selectedType}
          >
            {loading ? 'Procesando…' : 'Reprocesar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReprocessDocumentModal;
